import React from "react";
import { classNames } from "../../utils/classNames";
export var HeaderPanelWrapper = function (_a) {
    var children = _a.children;
    return React.createElement("div", null, children);
};
export var HeaderPanels = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classNames("header--panels", className !== null && className !== void 0 ? className : "") }, children));
};
